import type FeatureFlagsCompany from '@/model/FeatureFlagsCompany'
import type { FeatureFlagsGlobal } from '@/model/FeatureFlagsGlobal'

export function resolveStripeBillingEnabled(
  companyFlags?: FeatureFlagsCompany | null,
  globalFlags?: FeatureFlagsGlobal | null
): boolean {
  if (companyFlags?.stripeBillingEnabled != null) {
    return companyFlags.stripeBillingEnabled === true
  }
  return globalFlags?.stripeBillingEnabled === true
}
